export default [
	{
		path: '/locations',
		name: 'locations',
		component: () => import('@/views/Location/Locations.vue'),
		meta: { requiresAuth: true, permission: 'view_locations' }
	},
	{
		path: '/locations/create',
		name: 'locations.create',
		component: () => import('@/views/Location/CreateLocation.vue'),
		meta: { requiresAuth: true, permission: 'create_location' }
	}
]
